<template>
  <div class="w-full flex items-center flex-col justify-center md:grid md:grid-cols-2">
    <img
      v-for="(item, index) in list"
      :key="index"
      class="w-full"
      :src="item.logo"
      alt=""
      @click="handelUrl(item)"
    />
  </div>
</template>

<script setup>
import a from '@/assets/images/announcement.png'
const props = defineProps({
  list: {
    type: Array,
    default: () => []
  }
})
const handelUrl = (item) => {
  if (item.href) {
    window.open(item.href, '_blank')
  }
}
</script>

<style scoped></style>
